import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useCustomerAuth } from '../../contexts/CustomerAuthContext';
import { CustomerNotificationProvider } from '../../contexts/CustomerNotificationContext';
import CustomerNotificationMenu from './CustomerNotificationMenu';

const CustomerPortalLayout = ({ children, title, icon: Icon, showBackButton = true }) => {
  const navigate = useNavigate();
  const { logout } = useCustomerAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <CustomerNotificationProvider>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
        {/* Header */}
        <header className="bg-white dark:bg-gray-800 shadow-sm border-b border-gray-200 dark:border-gray-700">
          <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
            <div className="flex items-center justify-between py-3 sm:py-4">
              <div className="flex items-center min-w-0 flex-1">
                {showBackButton && (
                  <button
                    onClick={() => navigate('/dashboard')}
                    className="mr-2 sm:mr-4 p-1.5 sm:p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors flex-shrink-0"
                  >
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>
                )}
                {Icon && (
                  <div className="flex items-center min-w-0">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 dark:text-blue-400 mr-2 sm:mr-3 flex-shrink-0" />
                    <h1 className="text-base sm:text-xl font-bold text-gray-900 dark:text-white truncate">
                      {title}
                    </h1>
                  </div>
                )}
                {!Icon && title && (
                  <h1 className="text-base sm:text-xl font-bold text-gray-900 dark:text-white truncate">
                    {title}
                  </h1>
                )}
              </div>
              <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
                <CustomerNotificationMenu />
                <button
                  onClick={handleLogout}
                  className="inline-flex items-center px-2 sm:px-4 py-1.5 sm:py-2 border border-transparent text-xs sm:text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
                >
                  <LogOut className="w-3 h-3 sm:w-4 sm:h-4 sm:mr-2" />
                  <span className="hidden sm:inline">Çıkış Yap</span>
                </button>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        {children}
      </div>
    </CustomerNotificationProvider>
  );
};

export default CustomerPortalLayout;
